"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdvancedSearchTextFieldOperatorOptions = void 0;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const useAdvancedSearchTextFieldOperatorOptions = () => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return [
        {
            label: t('advancedSearch.operators.beginsWith'),
            value: 'begins-with',
        },
        {
            label: t('advancedSearch.operators.notBeginWith'),
            value: 'not-begins-with',
        },
        {
            label: t('advancedSearch.operators.endsWith'),
            value: 'ends-with',
        },
        {
            label: t('advancedSearch.operators.notEndWith'),
            value: 'not-ends-with',
        },
        {
            label: t('advancedSearch.operators.contains'),
            value: 'contains',
        },
        {
            label: t('advancedSearch.operators.notContain'),
            value: 'not-contains',
        },
        {
            label: t('advancedSearch.operators.equals'),
            value: 'equals',
        },
        {
            label: t('advancedSearch.operators.notEquals'),
            value: 'not-equals',
        },
    ];
};
exports.useAdvancedSearchTextFieldOperatorOptions = useAdvancedSearchTextFieldOperatorOptions;
